import ReactDOM from "react-dom/client";

import { BrowserRouter } from 'react-router-dom';

import * as serviceWorker from './serviceWorker';
import App from './App';

import 'assets/scss/style.scss';


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
);

serviceWorker.unregister();
